import { useRoomViewStore } from 'store/roomView/roomView.store'
import { TPatientManagementModalProps } from './PatientManagementModal.types'
import { useState } from 'react'
import { EPatientStatus, TRoomViewRoom } from '../RoomView.types'
import { useUpdatePatientStatusMutation } from '../hooks/surgeries.hook'
import { enqueueSnackbar } from 'notistack'
import { formatDuration, getEndTimeFromDate, getTimeFromDate } from '../helpers'

export const usePatientManagementModalLogic = (
  props: TPatientManagementModalProps
) => {
  const { patient } = props
  const { scheduledSurgeries, rooms, patientStatusOptions, refetchAll } =
    useRoomViewStore()

  const [updatePatientStatus] = useUpdatePatientStatusMutation()

  const [roomMenuAnchorEl, setRoomMenuAnchorEl] = useState<null | HTMLElement>(
    null
  )

  const surgery = scheduledSurgeries.find(
    (surgery) => surgery.patient._id === patient._id
  )

  const time = surgery
    ? `${getTimeFromDate(surgery.procedure.dateTime)}–
  ${getEndTimeFromDate(
    surgery.procedure.dateTime,
    surgery.procedure.duration
  )} (${formatDuration(surgery.procedure.duration)})`
    : ''

  const handleMoveToRoom = async (room: TRoomViewRoom) => {
    if (!surgery) return
    try {
      await updatePatientStatus({
        variables: {
          procedureId: surgery._id,
          patientStatus: EPatientStatus.ASSIGN_ROOM,
          roomId: room.id,
        },
      })
      refetchAll()
      enqueueSnackbar(`Patient moved to room ${room.name}`, {
        variant: 'success',
      })
    } catch (error: unknown) {
      enqueueSnackbar((error as Error).message, {
        variant: 'error',
      })
    }
    setRoomMenuAnchorEl(null)
  }

  return {
    time,
    rooms,
    surgery,
    roomMenuAnchorEl,
    scheduledSurgeries,
    patientStatusOptions,
    handleMoveToRoom,
    setRoomMenuAnchorEl,
  }
}
